const spMenu = $('#js-sp-menu')
const menuInner = $('#js-sp-menu-inner')
const menuItems = $('#js-sp-menu-items')
let scrollPosition

$('[data-menu-toggle]').click(function() {
  if (spMenu.is('[aria-hidden]')) {
    scrollPosition = $(window).scrollTop()
    $('body')
      .addClass('is-fixed')
      .css({ top: -scrollPosition })
    spMenu.show().removeAttr('aria-hidden')
    if (menuInner.innerHeight() < menuItems.innerHeight()) {
      menuItems.css('height', menuItems.innerHeight())
    }
  } else {
    $('body')
      .removeClass('is-fixed')
      .css({ top: 0 })
    window.scrollTo(0, scrollPosition)
    spMenu.attr('aria-hidden', 'true')
    setTimeout(function() {
      spMenu.hide()
      menuItems.css('height', '')
    }, 800)
  }
})
